import styles from './Divider.module.scss'

export interface DividerProps {
  style?: React.CSSProperties
}
export const Divider = ({ style }: DividerProps) => {
  return <div className={styles.divider} style={style} />
}
